import ApiService from "../ApiService";

export default class AuthService {
  // for custom url, ex: get data from bucket
  static updateUser = async (data) => {
    const instance = await ApiService();
    return instance.post("/staff/subscribe", data);
  };

  static login = async (email, password, fcmToken) => {
    const instance = await ApiService();
    return instance.post(process.env.REACT_APP_API_URL_AUTH, {
      email,
      password,
      fcm_token_web: fcmToken,
    });
  };

  static logout = async () => {
    let params = {};
    if (process.env.REACT_APP_API_URL_LOGOUT === "/staff/logout") {
      const user = JSON.parse(localStorage.getItem("user"));
      const token = localStorage.getItem("token");
      params = {
        id: user.id,
        email: user.email,
        name: user.name.given_name,
        image_url: "",
        token: token,
        hotel: user.hotel,
        role: user.role,
        chat_type_id: 0,
        chat_handler: true,
      };
    }
    const instance = await ApiService();
    return instance.post(process.env.REACT_APP_API_URL_LOGOUT, params);
  };

  static checkPassword = async (params) => {
    const instance = await ApiService();
    return instance.post(`/check_password`, params);
  }

  static forgotPassword = async (params) => {
    const instance = await ApiService();
    return instance.post(`/forgot_password`, params);
  }
}
